import "../../styles/all.css"
import "./info.css"
import { useTranslation } from "react-i18next";
import g1 from "../../img/gallery-01.png"; // أو مسار الصورة اللي عندك
import g2 from "../../img/gallery-02.png";
import g3 from "../../img/gallery-03.jpg";
import g4 from "../../img/gallery-04 (1).png";
import g5 from "../../img/gallery-05.jpg";
import g6 from "../../img/gallery-06 (1).png";

function InfoSection() {
  const { t } = useTranslation();

  return (
    <div className="infoo">
      <div className="boxx">
        <div className="image">
          <img src={g1} alt={t("alt1")} />
        </div>
        <div className="text">
          <p>{t("text1")}</p>
        </div>
      </div>

      <div className="boxx">
        <div className="image">
          <img src={g2} alt={t("alt2")} />
        </div>
        <div className="text">
          <p>{t("text2")}</p>
        </div>
      </div>

      <div className="boxx">
        <div className="image">
          <img src={g3} alt={t("alt3")} />
        </div>
        <div className="text">
          <p>{t("text3")}</p>
        </div>
      </div>

      <div className="boxx">
        <div className="image">
          <img src={g4} alt={t("alt4")} />
        </div>
        <div className="text">
          <p>{t("text4")}</p>
        </div>
      </div>

      <div className="boxx">
        <div className="image">
          <img src={g5} alt={t("alt5")} />
        </div>
        <div className="text">
          <p>{t("text5")}</p>
        </div>
      </div>

      <div className="boxx">
        <div className="image">
          <img src={g6} alt={t("alt6")} />
        </div>
        <div className="text">
          <p>{t("text6")}</p>
        </div>
      </div>
    </div>
  );
}

export default InfoSection;